import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info);
  }

  signInAgain = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-emerald-50 to-white" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white border rounded-2xl shadow-sm p-8 text-center space-y-4">
          <AlertTriangle className="w-12 h-12 mx-auto text-amber-500" />
          <h1 className="text-2xl font-heading font-bold">Something went wrong</h1>
          <p className="text-sm text-muted-foreground">This page could not load. Try again, or sign in again if the problem continues.</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center">
            <Button onClick={() => window.location.reload()} className="rounded-full" data-testid="error-reload-btn">Try again</Button>
            <Button variant="outline" onClick={this.signInAgain} className="rounded-full" data-testid="error-signin-btn">Sign in again</Button>
          </div>
        </div>
      </div>
    );
  }
}
